
import React from 'react';
import Header from '../header';
import Navigation from '../navigation';

var Shell = function Shell(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      links = _ref.links,
      children = _ref.children;
  return React.createElement(
    'div',
    null,
    React.createElement(Header, { title: title, subtitle: subtitle, shadowOnScroll: true }),
    React.createElement(
      Navigation,
      null,
      links.map(function (link, index) {
        return React.cloneElement(link, { key: index });
      })
    ),
    React.createElement(
      'main',
      null,
      children
    )
  );
};

export default Shell;


//////////////////
// WEBPACK FOOTER
// ../es/js/shell/index.js
// module id = 292
// module chunks = 0